module.exports = __webpack_public_path__ + "fonts/windowsHello_70x70.17f797e4b0af646c979faf08931ef909.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/windowsHello_70x70.png
// module id = 805
// module chunks = 9